import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { label: '精选爆料', href: '#cards' },
  { label: '最新快讯', href: '#updates' },
  { label: '爆料热榜', href: '#ranking' },
  { label: '热门话题', href: '#topics' },
  { label: '爆料视频', href: '#media' },
  { label: '关于我们', href: '#about' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a href="#" className="flex items-center space-x-2 group">
            <span className="font-heading text-2xl font-bold text-foreground-950 tracking-tight group-hover:text-primary-500 transition-colors">
              每日爆料
            </span>
          </a>

          <nav className="hidden md:flex items-center space-x-1">
            <a
              href="#"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg hover:bg-primary-50/80 whitespace-nowrap"
            >
              首页
            </a>
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors rounded-lg hover:bg-primary-50/80 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 hover:text-primary-500 transition-colors"
            aria-label="打开菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <nav className="flex flex-col px-4 py-3 space-y-1">
            <a
              href="#"
              onClick={() => setMobileOpen(false)}
              className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50/80 rounded-lg transition-colors"
            >
              首页
            </a>
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50/80 rounded-lg transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}